import React from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';

import ProductivityTimelineWithTime from './productivityTimelineWithTime';
import BatchTimeLineWithTime from './batchTimeLineWithTime';
import GaugeRow from './GaugeRow';
import { ncFileStatuses } from './functions';
import MachineStatus from './machineStatus';
import NcFileChangeTile from './ncFileChangeTile';
import ActiveTilePicture from './activeTilePicture';
import { getLinkingModalConfig, Popup } from '@helpers';
import { fullWidth } from '@components/frame';
import ProductionInformation from '@components/productionInformation';
import NCFileType from '@components/common/NCFileType';
import { ActiveTileNCFileSnapshot } from './ActiveTileNCFileSnapshot';
import useManageActiveTile from '@components/wallboard/hooks/useManageActiveTile';

export default (props) => {
  const {
    machine,
    machineStatus = {},
    scale,
    font,
    C,
    batch,
    localTime,
    getMachineEventTimelineByBatchId,
    tileHeight,
    url,
    TouchableElement,
    convertTime,
    productionBatchId,
    offset,
    firstScheduledJob,
    isWithERP,
    oldMachineStatusDate,
    oldMachineStatus,
    Svg,
    tileWidth,
    tourIds,
    oeeValue,
  } = props;

  const {
    onTilePress,
    onNcFileSnapshotPress,
    lineHeight,
    isNcFileChanged,
    productivityStyle,
    statusOverlayStyle,
    partImageWebProps,
    ncFileId,
    ncFileStatus,
    ncFile,
    partId,
  } = useManageActiveTile({
    machine,
    machineStatus,
    scale,
    tileHeight,
    productionBatchId,
    oldMachineStatusDate,
    oldMachineStatus,
    tourIds,
  });

  const onSchedulePlaceholderPress = () => {
    if ([ncFileStatuses.Unknown, ncFileStatuses.Ignored, ncFileStatuses.Setup].includes(ncFileStatus)) {
      Popup({
        Component: (p) => (
          <NCFileType
            {...{
              ...p,
              selectedItem: machine,
              productionBatchId,
              ncFileId,
              ncFileName: ncFile,
            }}
          />
        ),
        ...getLinkingModalConfig(scale, fullWidth),
      });
      return;
    }

    Popup({
      Component: (p) => (
        <ProductionInformation
          {...{
            ...p,
            selectedItem: machine,
            productionBatchId,
            selectedNCFileId: ncFileId,
            partId,
            shouldTakeNCFileDataFromMachine: true,
          }}
        />
      ),
      ...getLinkingModalConfig(scale, fullWidth),
    });
  };

  return [
    <View style={{ width: '100%', height: '43.28%' }} key="machineImage" {...partImageWebProps}>
      {url ? (
        <TouchableElement onPress={() => onTilePress({ clickOnImage: true })}>
          {({ boxStyle }) => (
            <View style={[boxStyle, { width: '100%', height: '100%' }]}>
              <ActiveTilePicture {...{ url, C, scale }} />
            </View>
          )}
        </TouchableElement>
      ) : (
        <View style={{ width: '100%', height: '100%' }}>
          <ActiveTileNCFileSnapshot C={C} machine={machine} tileHeight={tileHeight} />
          <TouchableElement onPress={onNcFileSnapshotPress}>
            {({ boxStyle }) => <View style={[boxStyle, { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }]} />}
          </TouchableElement>
        </View>
      )}
    </View>,
    <TouchableElement onPress={() => onTilePress({ clickOnImage: false })}>
      {({ boxStyle }) => (
        <View style={[boxStyle, { flex: 1 }]}>
          <View
            style={{
              width: '100%',
              flex: 1,
              paddingHorizontal: scale(10),
              justifyContent: 'space-between',
              paddingTop: scale(4),
              paddingBottom: scale(10),
            }}
            key="machineTime"
          >
            <View style={isNcFileChanged ? { flex: 1 } : undefined}>
              <View>
                <Animated.View style={productivityStyle}>
                  <ProductivityTimelineWithTime
                    {...{
                      lastUpdatedOn: machineStatus.lastUpdatedOn,
                      targetDuration: machineStatus.targetDuration,
                      status: machineStatus.status,
                      timeOffset: offset,
                      batch,
                      scale,
                      font,
                      C,
                      convertTime,
                      lineHeight,
                      tourId: tourIds?.productivityTimeline,
                    }}
                  />
                </Animated.View>
                <Animated.View
                  style={[
                    statusOverlayStyle,
                    { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, justifyContent: 'center', alignItems: 'center' },
                  ]}
                >
                  <MachineStatus {...{ font, scale, machineStatus, C, oldMachineStatusDate, oldMachineStatus, Svg }} />
                </Animated.View>
              </View>

              {isNcFileChanged ? (
                <NcFileChangeTile {...{ C, font, ncFileName: ncFile, scale, style: { flex: 1 } }} />
              ) : (
                <View style={{ marginTop: scale(4) }}>
                  <BatchTimeLineWithTime
                    {...{
                      productionBatchId,
                      convertTime,
                      batch,
                      scale,
                      C,
                      localTime,
                      font,
                      getMachineEventTimelineByBatchId,
                      offset,
                      lineHeight,
                      tileWidth,
                      status: machineStatus.status,
                      tourId: tourIds?.batchTimeline,
                    }}
                  />
                </View>
              )}
            </View>
            {!isNcFileChanged && (
              <GaugeRow
                {...{
                  batch,
                  oeeValue,
                  firstScheduledJob,
                  ncFileStatus,
                  isWithERP,
                  tileWidth,
                  scale,
                  font,
                  C,
                  onSchedulePlaceholderPress,
                  tourIds: tourIds
                    ? {
                        piecesProgress: tourIds.piecesProgress,
                        oeeGauge: tourIds.oeeGauge,
                        scheduleGauge: tourIds.scheduleGauge,
                      }
                    : undefined,
                }}
              />
            )}
          </View>
        </View>
      )}
    </TouchableElement>,
  ];
};
